import {
  HttpClient,
  JSON_STRING,
  clientName,
  baseUrl,
  MHTTPCL
} from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../booking/services/booking-service";
import { CONTACTS_URL } from "../../contacts/services/contact_groups.service";
import { combineServiceMethods } from "../../../global/service";

export const ACCOUNTING_URL = "/accounting.pl";

export const InvoiceReminderService = {
  findInvoiceReminders: () =>
    HttpClient.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      output: JSON_STRING
    }),
  findInvoiceReminderDetails: ({ invoice_reminder_id }) =>
    HttpClient.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "invoice_reminder_data",
      invoice_reminder_id
    }),
  findInvoiceReminderContacts: ({ invoice_reminder_contact_id }) =>
    HttpClient.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "edit_invoice_reminder_contact",
      output: JSON_STRING,
      invoice_reminder_contact_id
    }),

  modalNewInvoiceReminder: () =>
    MHTTPCL.get(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "modal_new_invoice_reminder"
    }),

  addNewInvoiceReminder: ({
    date,
    subject,
    account_check_date,
    exclude_cost,
    invoice_project_list
  }) =>
    MHTTPCL.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "create_invoice_reminder",
      date: date,
      subject: subject,
      account_check_date: account_check_date,
      exclude_cost: exclude_cost,
      invoice_project_list: JSON.stringify(invoice_project_list),
      output: JSON_STRING
    }),

  deleteInvoiceReminderPos: invoice_reminder_pos_id =>
    MHTTPCL.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "delete_invoice_reminder_pos",
      invoice_reminder_pos_id
    }),

  totalAmountDueOfPos: invoice_reminder_contact_id =>
    MHTTPCL.get(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "total_amount_due_of_pos",
      invoice_reminder_contact_id: invoice_reminder_contact_id
    }),

  removeInvoiceReminder: invoice_reminder_id =>
    MHTTPCL.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "delete_invoice_reminder",
      invoice_reminder_id
    }),
  removeInvoiceContact: invoice_reminder_contact_id =>
    MHTTPCL.post(ACCOUNTING_URL, {
      section: "invoice_reminder",
      action: "delete_invoice_reminder_contact",
      invoice_reminder_contact_id
    })
};
